module.exports = __webpack_public_path__ + "img/care-team.411859a5.png";